module.exports = __webpack_public_path__ + "img/core6.98a3f7c0.png";